var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50001 15.8333C7.50001 16.4583 7.32501 17.05 7.01668 17.55C6.44168 18.5167 5.38334 19.1667 4.16668 19.1667C2.95001 19.1667 1.89168 18.5167 1.31668 17.55C1.00835 17.05 0.833344 16.4583 0.833344 15.8333C0.833344 13.9917 2.32501 12.5 4.16668 12.5C6.00834 12.5 7.50001 13.9917 7.50001 15.8333Z",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86786 15.8329L3.69286 16.6579L5.46786 15.0162",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7929 5.87506C14.5929 5.84172 14.3845 5.8334 14.1679 5.8334H5.83452C5.60118 5.8334 5.37618 5.85006 5.15952 5.8834C5.27618 5.65006 5.44285 5.43342 5.64285 5.23342L8.35118 2.51675C9.49285 1.38341 11.3428 1.38341 12.4845 2.51675L13.9428 3.99171C14.4762 4.51671 14.7595 5.18339 14.7929 5.87506Z",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 9.99992V14.1666C18.3333 16.6666 16.6667 18.3333 14.1667 18.3333H6.35832C6.61666 18.1166 6.84166 17.8499 7.01666 17.5499C7.32499 17.0499 7.49999 16.4583 7.49999 15.8333C7.49999 13.9916 6.00832 12.4999 4.16666 12.4999C3.16666 12.4999 2.27499 12.9416 1.66666 13.6332V9.99992C1.66666 7.73325 3.03332 6.14992 5.15832 5.88325C5.37499 5.84992 5.59999 5.83325 5.83332 5.83325H14.1667C14.3833 5.83325 14.5917 5.84158 14.7917 5.87491C16.9417 6.12491 18.3333 7.71659 18.3333 9.99992Z",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 10.4166H15.8333C14.9167 10.4166 14.1667 11.1666 14.1667 12.0833C14.1667 13 14.9167 13.75 15.8333 13.75H18.3333",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.d7515513969e0702973492abaa5666d7.svg";
export { ForwardRef as ReactComponent };